import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import formatDate from "../../util/Date";
import { DatePicker }
  from
  "antd"
  ;
import dayjs from 'dayjs';
import "react-datepicker/dist/react-datepicker.css";
import * as api from "../../constants/api";
import { adalApiFetch } from "../../adalConfig";
import ReactTable from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-table/react-table.css";
import { Button } from "@material-ui/core";
import { Checkbox } from "@material-ui/core";
import { toastError } from "../../util/CommonFunctions";
import NavMenu from "../NavMenu";

import "react-day-picker/lib/style.css";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css";

import Moment from "moment";
import AuditTrailPopUp from "../auditTrail";

import { Table } from 'antd';
import { Input, Select, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { Divider } from 'antd';
import 'antd/dist/reset.css';
import { Col, Row } from 'antd';
import { Tag } from 'antd';
import { toast } from 'react-toastify';

const { RangePicker } = DatePicker;

class PcustAssignmentNew extends Component {
  constructor(props) {
    super(props);

    this.onUnload = this.onUnload.bind(this);
    var dateObj = new Date();
    dateObj.setDate(1);

    this.state = {
      GetMoreEnabled: false,
      defaultOption: { key: 0, value: "All" },
      Registrations: [],
      DisplayedCount: 0,
      Count: 0,
      Take: 10,
      ShowFilters: true,
      selectionAssign: [],     // for Send to Queue
      selectionStatus: [],     // for Assign PCUST Case Status
      Filters: {
        LicenseTypeValue: "",
        FamilyTypeValue: "",
        StatusValue: props.statusFilter ? props.statusFilter : "",
        StatusEnabled: props.statusFilter ? false : true,
        StatusDisplay: props.statusDisplay ? props.statusDisplay : "",
        EmailValue: "",
        AccountName: "",
        ClaimTypeValue: "",
        EntitlementValue: "",
        DateFromValue: dateObj.toISOString(),
        DateToValue: new Date().toISOString(),
      },
      RetainState: {
        SortedBy: "id",
        SortOrder_Desc: true,
        PageNo: 0,
      },
      LicenseTypes: [],
      FamilyTypes: [],
      Statuses: [],
      ClaimTypes: [],
      StartDate: null,
      EndDate: null,
      IsLoaded: false,
      IsFiltering: false,
      StartDateFilter: null,
      EndDateFilter: null,
      filterSelected: "This Month",
      pagination: {},
      loading: false,

      regID: "",
      pakid: "",
      emailID: "",
      accountName: "",
      licenseTypeLabel: "All",
      productFamilyLabel: ["All"],
      productFamilyValue: [0],
      licenseTypeValue: 0,
      statusValue: ["PCUST", "PCUSTCASE"],
      dateRange: [
        dayjs(dateObj),
        dayjs()
      ],
      isInitial: true
    };
    this.dateFilterClicked = this.dateFilterClicked.bind(this);
    this.handleSelectDefinedRange = this.handleSelectDefinedRange.bind(this);
    this.toggleAssignSelection = this.toggleAssignSelection.bind(this);
    this.toggleStatusSelection = this.toggleStatusSelection.bind(this);
    this.postUpdateUserName = this.postUpdateUserName.bind(this);
    this.postUpdatePCustCaseStatus = this.postUpdatePCustCaseStatus.bind(this)
  }
  buildFilter = () => {

    let filterString = "";

    const {
      regID,
      pakid,
      emailID,
      accountName,
      licenseTypeValue,
      productFamilyValue,
      statusValue,
      dateRange
    } = this.state;

    if (regID) {
      if (filterString) filterString += "&&";
      filterString += "Id=" + JSON.stringify(regID);
    }

    if (pakid) {
      if (filterString) filterString += "&&";
      filterString += "PakId.Contains(" + JSON.stringify(pakid) + ")";
    }

    if (emailID) {
      if (filterString) filterString += "&&";
      filterString += "EmailID.Contains(" + JSON.stringify(emailID) + ")";
    }

    if (accountName) {
      if (filterString) filterString += "&&";
      filterString +=
        "CompanyDetail.CompanyName.Contains(" +
        JSON.stringify(accountName) +
        ")";
    }

    if (statusValue && statusValue.length > 0) {
      if (filterString) filterString += "&&";

      const statusFilter = statusValue
        .map(x => `RequestStatusName=${JSON.stringify(x)}`)
        .join("||");

      filterString += `(${statusFilter})`;
    }

    if (licenseTypeValue && licenseTypeValue !== "All") {
      if (filterString) filterString += "&&";
      filterString += "LicenseTypeId=" + licenseTypeValue;
    }

    if (productFamilyValue && productFamilyValue.length > 0 && !productFamilyValue.includes(0)) {
      if (filterString) filterString += "&&";
     
      const familyFilter = productFamilyValue
        .map(x => `ProductFamilyId=${x}`)
        .join("||");
     
      filterString += `(${familyFilter})`;
    }

    if (dateRange && dateRange.length === 2) {

      const from = dateRange[0].format("M/D/YYYY, h:mm:ss a");
      const to = dateRange[1].format("M/D/YYYY, h:mm:ss a");

      if (filterString) filterString += "&&";

      filterString += "CreationTime.Date>=" + JSON.stringify(from);
      filterString += "&&CreationTime.Date<=" + JSON.stringify(to);

    }
    else if (this.state.Filters) {
      const { DateFromValue, DateToValue } = this.state.Filters;

      if (DateFromValue && DateToValue) {

        if (DateFromValue) {
          if (filterString !== "") {
            filterString += "&&";
          }
          filterString +=
            "CreationTime.Date>=" +
            JSON.stringify(DateFromValue);
        }
        if (DateToValue) {
          if (filterString !== "") {
            filterString += "&&";
          }
          filterString +=
            "CreationTime.Date<=" + JSON.stringify(DateToValue);
        }
      }
    }

    return filterString;
  };
  fetchData = (takes, skips, sortfields, sortorders, isSearch, isClear) => {

    this.setState({ loading: true });
    let fil = this.buildFilter();
    console.log(fil)
    if (isClear) {
      fil = '';
    }
    // let orderby = "id desc";
    var orderby;
    if (sortfields) {
      const order = sortorders === "ascend" ? "asc" : "desc";
      orderby = `${sortfields} ${order}`;
    }
    let options = {
      params: {
        //take: this.state.Take,
        filter: fil,
        take: (takes.results) ? takes.results : 10,
        skip: (takes.results * takes.page - takes.results) ? takes.results * takes.page - takes.results : 0,
        orderby: orderby

      },
    };

    adalApiFetch(axios, api.GET_REGISTRATIONSQUICKSEARCH, options) //testData.json api.GET_REGISTRATIONS
      .then((response) => {

        const modifiedData = response.data.records.map((r) => {
          r.creationTime = formatDate(new Date(r.creationTime));
          r.creationTimeTo = formatDate(new Date(r.creationTime));
          r.creationTimeFrom = formatDate(new Date(r.creationTime));
          r.entitlement = r.pakid && r.pakid !== "" ? r.pakid : r.serialNumber;
          return r;
        })
        this.setState(prevState => ({
          data: modifiedData,
          loading: false,
          pagination: {
            ...prevState.pagination,
            total: response.data.totalCount,
            current: isSearch ? 1 : prevState.pagination.current,
            pageSize: 10
          }
        }));
      }).then(() => {
        if (isClear) {
          this.clearFields()
        }
      })
      .catch((error) => {
        console.log(error);

      });
  };

  handleRegIDChange = (e) => {
    this.setState({ regID: e.target.value });
  };

  handlePAKIDIDChange = (e) => {
    this.setState({ pakid: e.target.value });
  };

  handleEmailIDChange = (e) => {
    this.setState({ emailID: e.target.value });
  };

  handlesetAccountNameChange = (e) => {
    this.setState({ accountName: e.target.value });
  };

  handleLicenseTypeChange = (value) => {

    const { LicenseTypes } = this.state;

    const selected = LicenseTypes.find(x => x.value === value);

    this.setState({
      licenseTypeValue: selected ? selected.key : "",
      licenseTypeLabel: value
    });

  };

  handleProductFamilyChange = (values) => {

    const { FamilyTypes } = this.state;

    const selectedKeys = FamilyTypes
      .filter(x => values.includes(x.value))
      .map(x => x.key);

    this.setState({
      productFamilyValue: selectedKeys,
      productFamilyLabel: values
    });
  };

  handleStatusChange = (values) => {
    this.setState({ statusValue: values });
  };

  onDateRangeChange = (dates) => {
    this.setState({ dateRange: dates });
  };

  searchOnClick = () => {

    this.setState({ isInitial: false });
    this.fetchData(
      { results: 10, page: 1 }, // pageSize = 10, pageNumber = 1
      null, // skip (will calculate)
      null, // sortField
      null, // sortOrder
      true, // isSearch
      false // isClear
    );
    this.setState({
      pagination: {
        current: 1,
        defaultCurrent: 1
      }
    });

  }
  searchBlurClick = () => {

    this.setState({ isInitial: false });
    this.fetchData(true, true, true, true, true, false);
    this.setState({
      pagination: {
        current: 1,
        defaultCurrent: 1
      }
    });
  }

  clearFilterOnClick = () => {
    this.setState({
      regID: "",
      pakid: "",
      emailID: "",
      accountName: "",
      licenseTypeLabel: "",
      statusValue: [],
      productFamilyLabel: [],
      productFamilyValue: [],
      dateRange: []
    });
  };

  toggleAssignSelection = (key) => {
    let selectionAssign = [...this.state.selectionAssign];
    const index = selectionAssign.indexOf(key);

    if (index >= 0) {
      selectionAssign.splice(index, 1);
    } else {
      selectionAssign.push(key);
    }

    this.setState({ selectionAssign });
  };

  toggleStatusSelection = (key) => {
    let selectionStatus = [...this.state.selectionStatus];
    const index = selectionStatus.indexOf(key);

    if (index >= 0) {
      selectionStatus.splice(index, 1);
    } else {
      selectionStatus.push(key);
    }

    this.setState({ selectionStatus });
  };
  
  componentDidMount() {
    this.getLookups();
    this.getInitial(true);

    window.addEventListener("beforeunload", this.onUnload);
    var flter = JSON.parse(sessionStorage.getItem("Filters"));
    var pg = parseInt(sessionStorage.getItem("page"));

    var sortedBy = sessionStorage.getItem("SortedBy");
    var sortOrder_Desc = sessionStorage.getItem("SortOrderDesc");

    var pageSize = parseInt(sessionStorage.getItem("PgSz"));

    if (sortedBy) {
      let rs = this.state.RetainState;
      rs.SortedBy = sortedBy;
      this.setState({ RetainState: rs });
    }
    if (sortOrder_Desc) {
      var isTrueSet = sortOrder_Desc.toLowerCase() === "true";
      let rs = this.state.RetainState;
      rs.SortOrder_Desc = isTrueSet;
      this.setState({ RetainState: rs });
    }

    if (pageSize) {
      this.setState({ Take: parseInt(pageSize) });
    }

    if (flter) {
      var hasDateFilter = this.getFilterDate(flter);
      if (hasDateFilter) {
        this.setState({ StartDate: new Date(hasDateFilter) });
      }
      this.setState({ Filter: flter });
    }

    if (pg) {
      let rs = this.state.RetainState;
      rs.PageNo = parseInt(pg);
      this.setState({ RetainState: rs });
    }
  }

  handleTableChange = (pagination, filters, sorter) => {
    console.log(pagination, sorter);

    this.setState({ pagination });
    var sortField = sorter.column && sorter.column.sortField
      ? sorter.column.sortField
      : sorter.field;

    this.fetchData(
      { results: pagination.pageSize, page: pagination.current },
      null,
      sortField,
      sorter.order,
      false,
      false
    );
  };
  getFilterDate(flter) {
    for (let i = 0; i < flter.length; i++) {
      if (flter[i]["id"] === "creationTime") {
        return flter[i]["value"];
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    var pg = parseInt(sessionStorage.getItem("page"));
    var pageCount = parseInt(sessionStorage.getItem("PgCnt"));
    if (pg > pageCount) {
      let rs = this.state.RetainState;
      rs.PageNo = pageCount - 1 === -1 ? 0 : pageCount - 1;
      this.setState({ RetainState: rs });
    }
    sessionStorage.setItem("Filter", JSON.stringify(this.state.Filters));
    sessionStorage.setItem("page", parseInt(this.state.RetainState.PageNo));
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onUnload);
  }

  onUnload(event) {
    sessionStorage.clear();
  }
  handleSelectDefinedRange(ranges) {
    this.setState({
      Filter: [],
      StartDateFilter: null,
      EndDateFilter: null,
      StartDate: null,
      EndDate: null,
    });

    this.setState({
      Filter: [
        { id: "creationTimeFrom", value: ranges["selection"].startDate },
        {
          id: "creationTimeTo",
          value: ranges["selection"].endDate.setDate(
            ranges["selection"].endDate.getDate() + 1
          ),
        },
      ],
      StartDate: null,
      EndDate: null,
    });
  }

  handleChangeStartDateFilter = (value, accessor) => {
    let filtered = this.state.Filter;
    let insertNewFilter = 1;
    if (filtered.length) {
      filtered.forEach((filter, i) => {
        if (filter["id"] === accessor) {
          if (value === "" || !value) {
            filtered.splice(i, 1);
          } else {
            filter["value"] = value;
          }
          insertNewFilter = 0;
        }
      });
    }
    if (insertNewFilter) {
      filtered.push({ id: accessor, value: value });
    }

    this.setState({ Filter: filtered });
  };
  dateFilterClicked(filterName, value = "") {
    let filtsel = "None";
    let f = this.state.Filters;
    let dateObj = new Date();
    switch (filterName) {
      case "Today":
        f.DateFromValue = new Date().toLocaleString();
        f.DateToValue = new Date().toLocaleString();
        this.setState({
          Filter: [],
          Filters: f,
          IsLoaded: false,
          filterSelected: "Today",
          StartDateFilter: null,
          EndDateFilter: null,
          StartDate: null,
        });
        this.getInitial(true);
        break;
      case "This Week":
        f.DateFromValue = Moment().startOf("isoweek").toDate();
        f.DateToValue = Moment().endOf("isoweek").toDate();
        this.setState({
          Filter: [],
          Filters: f,
          IsLoaded: false,
          filterSelected: "This Week",
          StartDateFilter: null,
          EndDateFilter: null,
          StartDate: null,
        });
        this.getInitial(true);
        break;
      case "This Month":
        f.DateFromValue = Moment().startOf("month").toDate();
        f.DateToValue = Moment().endOf("month").toDate();
        console.log("fromdate" + f.DateFromValue);
        console.log("Todate" + f.DateToValue);

        this.setState({
          Filter: [],
          Filters: f,
          IsLoaded: false,
          filterSelected: "This Month",
          StartDateFilter: null,
          EndDateFilter: null,
          StartDate: null,
        });
        this.getInitial(true);

        break;
      case "All":
        let d = new Date();
        d.setFullYear(2018);
        f.DateFromValue = d.toLocaleString();
        f.DateToValue = new Date().toLocaleString();
        this.setState({
          Filter: [],
          Filters: f,
          IsLoaded: false,
          filterSelected: "All",
          StartDateFilter: null,
          EndDateFilter: null,
          StartDate: null,
        });
        this.getInitial(true);
        break;

      case "FromDate":
        if (value) {
          f.DateFromValue = value.toISOString();
        } else {
          let d = new Date();
          d.setFullYear(2018);
          f.DateFromValue = d.toLocaleString();
        }
        if (this.state.EndDateFilter) {
          f.DateToValue = this.state.EndDateFilter;
        } else {
          f.DateToValue = new Date().toLocaleString();
        }
        if (!value && !this.state.EndDateFilter) {
          f.DateFromValue = Moment().startOf("month").toDate();
          f.DateToValue = Moment().endOf("month").toDate();
          filtsel = "This Month";
        }
        this.setState({
          Filter: [],
          Filters: f,
          IsLoaded: false,
          filterSelected: filtsel,
          StartDateFilter: value,
          StartDate: null,
        });
        this.getInitial(true);
        break;
      case "ToDate":
        if (value) {
          f.DateToValue = value.toISOString();
        } else {
          f.DateToValue = new Date().toLocaleString();
        }
        if (this.state.StartDateFilter) {
          f.DateFromValue = this.state.StartDateFilter;
        } else {
          let d = new Date();
          d.setFullYear(2018);
          f.DateFromValue = d.toLocaleString();
        }
        if (!value && !this.state.StartDateFilter) {
          f.DateFromValue = Moment().startOf("month").toDate();
          f.DateToValue = Moment().endOf("month").toDate();
          filtsel = "This Month";
        }
        this.setState({
          Filter: [],
          Filters: f,
          IsLoaded: false,
          filterSelected: filtsel,
          EndDateFilter: value,
          StartDate: null,
        });
        this.getInitial(true);
        break;
      default:
        break;
    }
  }
  render() {
    const {
      Registrations: data,
      LicenseTypes,
      FamilyTypes,
      Statuses,
      IsLoaded,
    } = this.state;

    const { canViewRWAMapping } = this.props;

    const licTypes = LicenseTypes.map((o) => {
      return (
        <option key={o.key} value={o.key}>
          {o.value}
        </option>
      );
    });
    const familyTypes = FamilyTypes.map((o) => {
      return (
        <option key={o.key} value={o.key}>
          {o.value}
        </option>
      );
    });
    const statuses = Statuses.map((o) => {
      return (
        <option key={o.key} value={o.key}>
          {o.value}
        </option>
      );
    });

    const columns = [
      {
        title: "ID",
        dataIndex: "id",
        key: "id",
        width: 100,
        sorter: true,
      },
      {
        title: "Entitlement",
        dataIndex: "entitlement",
        key: "entitlement",
        width: 290,
        sorter: true,
        sortField: "PAKID"
      },
      {
        title: "Type",
        dataIndex: "licenseTypeName",
        key: "licenseTypeName",
        width: 130,
        sorter: true,
      },
      {
        title: "Family",
        dataIndex: "productFamilyName",
        key: "productFamilyName",
        width: 100,
        sorter: true,
      },
      {
        title: "Email",
        dataIndex: "emailID",
        key: "emailID",
        width: 270,
        sorter: true,
      },
      {
        title: "Account Name",
        dataIndex: ["companyDetail", "companyName"],
        key: "companyName",
        sorter: true,
        sortField: "CompanyDetail.CompanyName"
      },
      {
        title: "Status",
        dataIndex: "requestStatusName",
        key: "requestStatusName",
        width: 120,
        sorter: true,
      },
      {
        title: "Owner Name",
        dataIndex: "userName",
        key: "userName",
        width: 120,
        sorter: true,
      },
      {
        title: "Assignment",
        dataIndex: "assignment",
        key: "assignment",
        width: 120,
        render: (_, record) => (
          <Checkbox
            className="checkbox"
            checked={
              this.state.selection &&
              this.state.selection.includes(record.id)
            }
            onChange={() => this.toggleAssignSelection(record.id)}
          />
        ),
      }, {
        title: "Awaiting NVES Case / Revert to PCUST",
        dataIndex: "modifyStatus",
        key: "modifyStatus",
        width: 200,
        render: (_, record) => (
          <Checkbox
            checked={this.state.selectionStatus.includes(record.id)}
            onChange={() => this.toggleStatusSelection(record.id)}
          />
        )
      },
      {
        title: "Date",
        dataIndex: "creationTime",
        key: "creationTime",
        width: 150,
        sorter: true,
        render: (value) => (value ? Moment(value).format("MM/DD/YYYY") : ""),
      },
      {
        title: "Action",
        key: "action",
        width: 120,
        render: (_, record) => {
          const showMatchState = record.requestStatusId === 2;
          return (
            <div className="flex">
              <Link
                className="auditTrailSty"
                to={{
                  pathname: "/detail/" + record.id,
                  state: { assignView: showMatchState },
                }}
              >
                <Button className='btn small auditBtn auditBtnPad' style={{ marginLeft: '0px', color: 'white', height: '95%', width: '85%', backgroundColor: '#76b200' }}
                  onClick={() =>
                    this.setState({ Filter: this.state.Filter })
                  }
                >
                  {showMatchState ? "Match" : "View"}
                </Button>
              </Link>
              <AuditTrailPopUp regID={record.id} />
            </div>
          );
        },
      },
    ];

    if (!IsLoaded) {
      return (
        <div className='loading-full'>
          <FontAwesomeIcon
            icon='spinner'
            spin
            className='color-nvgreen'
            size='2x'
          />
          <div className='loading-text'>loading page content</div>
        </div>
      );
    }

    const selectionRange = {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    };

    const AssignButton = (
      <Button
        variant='contained'
        size='small'
        onClick={this.postUpdateUserName}
        className="selectedBtn"
      >
        Assign To Me
      </Button>
    );

    const MatchingButton = (
      <a
        id="lictype"
        style={{ textDecoration: 'none' }}
        className="menu-item"
        href="/pcustmatchingnew"
      >
        <Button
          variant='contained'
          size='small'
          className="selectedBtn"
        >
          PCUST Matching
        </Button>
      </a>
    );
    return (
      <div className='content'>
        {canViewRWAMapping && <NavMenu />}
       <div>
          <div className=''>
            {<NavMenu />}
            <Divider orientation="left" plain>
              <Tag color="rgb(118, 178, 0)"> Custom Search</Tag>

            </Divider>
            <div>
              <Row>
                <Col span={4}>
                  <Input
                    value={this.state.regID}
                    onBlur={this.searchBlurClick}
                    addonBefore="Registration ID"
                    onChange={this.handleRegIDChange}
                  />

                </Col>
                <Col style={{ marginLeft: '10px' }} span={4}>

                  <Input
                    onChange={this.handlePAKIDIDChange}
                    addonBefore="Entitlement"
                    value={this.state.pakid}
                    onBlur={this.searchBlurClick}
                  />

                </Col>
                <Col style={{ marginLeft: '10px' }} span={4}>

                  <Input
                    onChange={this.handleEmailIDChange}
                    addonBefore="Email"
                    onBlur={this.searchBlurClick}
                    value={this.state.emailID}
                  />

                </Col>
                <Col style={{ marginLeft: '10px' }} span={4}>

                  <Input
                    onChange={this.handlesetAccountNameChange}
                    addonBefore="Account Name"
                    onBlur={this.searchBlurClick}
                    value={this.state.accountName}
                  />
                </Col>
              </Row>
              <Row style={{ margin: '10px' }}></Row>


              <Row>
                <Col span={4}>
                  <Tag  >License Type: </Tag>
                  <Select style={{ width: 180 }}
                    value={this.state.licenseTypeLabel}
                    onChange={this.handleLicenseTypeChange}
                    placeholder="Select License type"


                    options={LicenseTypes}
                  />
                </Col>
                <Col style={{ marginLeft: '8px' }} span={4}>
                  <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    <Tag>Product Family:</Tag>
                    <Select
                      mode="multiple"
                      allowClear
                      style={{ width: 210 }}
                      value={this.state.productFamilyLabel}
                      onChange={this.handleProductFamilyChange}
                      options={FamilyTypes}
                    />
                  </div>
                </Col>
                <Col style={{ marginLeft: '8px' }} span={4.5}>
                  <Tag  >Date Filter: </Tag>
                  <RangePicker
                    style={{ width: 220 }}
                    value={this.state.dateRange}
                    onChange={this.onDateRangeChange}
                    format="MM/DD/YYYY"
                  />
                </Col>
                <Col style={{ marginLeft: '8px' }} span={4.5}>
                  <div style={{ display: "flex", alignItems: "center", }}>
                    <Tag>Request Status:</Tag>
                    <Select
                      mode="multiple"
                      allowClear
                      style={{ width: 220 }}
                      placeholder="Select Status"
                      value={this.state.statusValue}
                      onChange={this.handleStatusChange}
                      options={Statuses}
                    />
                  </div>
                </Col>


              </Row>

              <Row style={{ marginTop: '20px' }}>
                <Col style={{ marginLeft: '10px' }} span={2}>
                  <Button onClick={this.searchOnClick} className='btn small auditBtn' style={{ marginLeft: '0px', color: 'white', backgroundColor: '#76b200', height: '80%' }} type="primary" icon={<SearchOutlined />}>
                    Search
                  </Button>
                </Col>
                <Col style={{ marginLeft: '10px' }} span={2}>
                  <Button onClick={this.clearFilterOnClick} className='btn small auditBtn' style={{ marginLeft: '10px', color: 'white', backgroundColor: '#76b200', height: '80%' }} type="primary" >
                    Clear Filters
                  </Button>
                </Col>
                <Col style={{ marginLeft: '10px' }} span={2}>
                  <Button
                    onClick={this.postUpdateUserName}
                    className='btn small auditBtn'
                    style={{ marginLeft: '20px', color: 'white', backgroundColor: '#76b200', height: '80%' }} type="primary"
                  >
                    Assign To Me
                  </Button>
                </Col>
                <Col style={{ marginLeft: '10px' }} span={2}>
                  <a
                    id="lictype"
                    style={{ textDecoration: 'none' }}
                    className="menu-item"
                    href="/pcustmatchingnew"
                  >
                    <Button
                      className='btn small auditBtn'
                      style={{ marginLeft: '20px', color: 'white', backgroundColor: '#76b200', height: '80%' }} type="primary"
                    >
                      PCUST Matching
                    </Button>
                  </a>
                </Col>
                <Col style={{ marginLeft: '10px' }} span={3}>
                  <Button
                    onClick={() => this.postUpdatePCustCaseStatus("PCUSTCASE")}
                    className='btn small auditBtn'
                    style={{ marginLeft: '20px', color: 'white', backgroundColor: '#76b200', height: '80%' }}
                    type="primary"
                  >
                    Set Awaiting NVES Case
                  </Button>
                </Col>
                <Col style={{ marginLeft: '10px' }} span={2}>
                  <Button
                    onClick={() => this.postUpdatePCustCaseStatus("PCUST")}
                    className='btn small auditBtn'
                    style={{ marginLeft: '20px', color: 'white', backgroundColor: '#76b200', height: '80%' }}
                    type="primary"
                  >
                    Set PCUST
                  </Button>
                </Col>
              </Row>
              <Divider />
            </div>
          </div>
          <Table
            size="middle"
            rowClassName={() => "rowClassName1"}
            bordered
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={
              this.state.data && this.state.data.length > 0
                ? this.state.data
                : data
            }
            pagination={this.state.pagination}
            loading={this.state.loading}
            onChange={this.handleTableChange}
          />
        </div></div>
    );
  }

  defaultFilter(filter, row, column) {
    return (
      row[filter.id] &&
      row[filter.id].toLowerCase().includes(filter.value.toLowerCase())
    );
  }


  getInitial(useFilter) {
    const filterString = this.buildFilter();

    let options = {
      params: {
        //take: this.state.Take,
        filter: filterString,
      },
    };
    console.log(filterString)
    if (!useFilter) {
      delete options.params;
    }
    adalApiFetch(axios, api.GET_REGISTRATIONSQUICKSEARCH, options) //testData.json api.GET_REGISTRATIONS
      .then((response) => {
        const modifiedData = response.data.records.map((r) => {
          r.creationTime = formatDate(new Date(r.creationTime));
          r.creationTimeTo = formatDate(new Date(r.creationTime));
          r.creationTimeFrom = formatDate(new Date(r.creationTime));
          r.entitlement = r.pakid && r.pakid !== "" ? r.pakid : r.serialNumber;

          return r;
        });

        this.setState({
          IsLoaded: true,
          data: modifiedData,
          Count: modifiedData.Length,
          DisplayedCount: this.state.Take,
          GetMoreEnabled: true,
        });
      })
      .catch((error) => {
        console.log(error);
        toastError(error.response);
      });
  }

  getLookups() {
    adalApiFetch(axios, api.GET_LOOKUPS, {})
      .then((response) => {
        response.data.LicenseType.unshift(this.state.defaultOption);
        response.data.ProductFamily.unshift(this.state.defaultOption);
        response.data.Status.unshift({ key: -1, value: "In progress" });
        response.data.Status.unshift(this.state.defaultOption);
        response.data.ClaimType.unshift(this.state.defaultOption);
        this.setState({
          LicenseTypes: response.data.LicenseType,
          FamilyTypes: response.data.ProductFamily,
          Statuses: response.data.Status,
          ClaimTypes: response.data.ClaimType,
        });
      })
      .catch((error) => {
        console.log(error);
        if (error.response) {
          console.log(error.response);
        }
      });
  }
  postUpdateUserName() {
    if (this.state.selectionAssign.length > 0) {


      let data = {
        registrationIds: this.state.selectionAssign,

        userName: this.props.userName,
      };

      adalApiFetch(axios, api.POST_UPDATE_USERNAME, {
        method: "post",
        data: data,
      })
        .then((response) => {
          console.log(response);
          if (response.data.Success > 0) {

            this.setState({
              Filter: [{ id: "requestStatusName", value: "2" }],
              selectionAssign: [],

              IsLoaded: false,


            });
            this.getInitial(true);
          }
        })
        .catch((error) => {
          console.log(error);
          if (error.response) {
            console.log(error.response);
            //   toastError(error.response.data["Message"]);
            this.setState({ StatusLoaded: true });
          }
        });
    } else {
      toastError("Please select at least one record.");
    }
  }
  postUpdatePCustCaseStatus = (targetStatus) => {
    const { selectionStatus, data } = this.state;

    if (selectionStatus.length === 0) {
      toastError("Please select at least one record.");
      return;
    }

    // Filter to only include rows where status is different from targetStatus
    const rowsToUpdate = data.filter(
      (row) =>
        selectionStatus.includes(row.id) && row.requestStatusName !== targetStatus
    );

    if (rowsToUpdate.length === 0) {
      toast.info(`Selected records already have status '${targetStatus}'.`);
      return; // nothing to update
    }

    const payload = {
      registrationIds: rowsToUpdate.map((r) => r.id),
      userName: this.props.userName,
      status: targetStatus,
    };

    adalApiFetch(axios, api.POST_UPDATE_PCUST_CASE, {
      method: "post",
      data: payload,
    })
      .then((response) => {
        if (response.data.Success > 0) {
          this.setState({
            selectionStatus: [],
            IsLoaded: false,
          });
          this.getInitial(true);
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response) {
          toastError(error.response);
        }
      });
  };
}

export default PcustAssignmentNew;
